<div class="otp-container">
    <div class="otp-content">
        <div class="logo-section">
            <!-- Using Slack logo as logo is not yet present -->
            <div class="logo-icon-wrapper">
                <img src="assets/images/logo.png" class="logo" />
            </div>

        </div>

        <form [formGroup]="otpForm" (ngSubmit)="onSubmit()" class="otp-form">
            <h2 class="welcome-text">Enter 2FA Code</h2>
            <p class="sub-text my-2">Enter the code generated by your authenticator app</p>

            <div class="otp-inputs">
                <input id="otp1" type="text" maxlength="1" formControlName="otp1" class="otp-input" (input)="moveToNext($event, 'otp2')" (keydown)="onKeyDown($event, 'otp1', null)">

                <input id="otp2" type="text" maxlength="1" formControlName="otp2" class="otp-input" (input)="moveToNext($event, 'otp3')" (keydown)="onKeyDown($event, 'otp2', 'otp1')">

                <input id="otp3" type="text" maxlength="1" formControlName="otp3" class="otp-input" (input)="moveToNext($event, 'otp4')" (keydown)="onKeyDown($event, 'otp3', 'otp2')">

                <input id="otp4" type="text" maxlength="1" formControlName="otp4" class="otp-input" (input)="moveToNext($event, 'otp5')" (keydown)="onKeyDown($event, 'otp4', 'otp3')">

                <input id="otp5" type="text" maxlength="1" formControlName="otp5" class="otp-input" (input)="moveToNext($event, 'otp6')" (keydown)="onKeyDown($event, 'otp5', 'otp4')">

                <input id="otp6" type="text" maxlength="1" formControlName="otp6" class="otp-input" (keydown)="onKeyDown($event, 'otp6', 'otp5')">
            </div>


            <button type="submit" class="verify-button my-3" [disabled]="!otpForm.valid">
               Verify
            </button>


        </form>
    </div>
</div>